import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000" >
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />n
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >

<path d="M2886 6827 c-12 -9 -17 -23 -14 -47 4 -45 33 -60 123 -60 132 -1 327
-65 459 -152 263 -172 436 -475 445 -778 2 -76 25 -106 70 -95 34 9 41 21 41
75 0 377 -216 733 -570 937 -156 91 -494 164 -554 120z"/>
<path d="M2875 6516 c-11 -17 -13 -30 -6 -48 12 -31 29 -38 93 -38 91 0 223
-44 323 -108 132 -85 234 -213 284 -360 24 -70 29 -103 30 -179 1 -57 24 -93
60 -93 37 0 51 27 51 95 0 154 -54 301 -164 448 -136 183 -375 307 -591 307
-57 0 -66 -3 -80 -24z"/>
<path d="M2892 6243 c-22 -8 -33 -50 -21 -77 11 -24 44 -36 100 -36 15 0 53
-9 83 -20 140 -53 236 -180 249 -329 4 -55 29 -91 63 -91 25 0 54 39 54 73 0
60 -54 237 -72 237 -5 0 -8 6 -8 14 0 7 -29 43 -65 79 -47 49 -85 76 -141 103
-86 41 -202 63 -242 47z"/>
<path d="M2154 6022 c-17 -11 -194 -361 -194 -382 0 -19 8 -20 108 -20 120 0
199 -16 273 -56 50 -27 127 -100 117 -110 -3 -3 -44 2 -91 11 -80 16 -91 16
-183 1 -143 -25 -244 -76 -330 -170 -130 -139 -176 -294 -139 -462 45 -205
186 -352 400 -419 71 -22 443 -33 467 -14 20 17 198 360 198 383 0 14 -23 16
-180 16 -218 0 -268 9 -320 59 -84 80 -54 220 58 266 57 24 164 19 227 -10
105 -50 143 -107 391 -595 51 -99 63 -115 89 -122 17 -4 120 -6 230 -5 179 2
200 4 203 19 3 17 -74 175 -278 573 -212 414 -297 575 -337 637 -12 21 -23 40
-23 44 0 6 -31 47 -85 114 -101 124 -236 208 -380 235 -81 16 -203 20 -221 7z"/>
<path d="M2892 5943 c-22 -9 -33 -40 -22 -67 7 -19 21 -28 55 -37 50 -13 85
-48 85 -85 0 -26 32 -64 53 -64 7 0 23 7 35 16 44 30 22 129 -43 191 -42 40
-121 63 -163 46z"/>
<path d="M4442 5198 l3 -683 103 -3 c97 -3 102 -2 102 18 0 22 20 26 49 10 10
-5 48 -14 84 -20 93 -15 186 7 270 63 259 175 226 549 -61 688 -63 31 -200 38
-268 15 -26 -9 -54 -16 -61 -16 -10 0 -13 59 -13 305 l0 305 -105 0 -105 0 2
-682z m478 -130 c163 -83 108 -336 -74 -340 -62 -1 -111 18 -145 57 -56 64
-63 158 -18 227 28 42 99 78 152 78 22 0 61 -10 85 -22z"/>
<path d="M6290 4936 l0 -396 208 0 c216 0 269 7 347 48 64 33 117 98 150 187
15 38 19 76 19 160 0 95 -4 119 -26 172 -30 74 -59 111 -118 151 -86 60 -114
65 -357 70 l-223 4 0 -396z m420 195 c84 -41 122 -137 101 -254 -22 -124 -85
-165 -253 -167 l-68 0 0 218 c0 120 3 222 8 226 15 17 166 0 212 -23z"/>
<path d="M7341 5308 c-4 -13 -27 -75 -50 -138 -23 -63 -49 -131 -56 -150 -45
-115 -175 -466 -175 -473 0 -4 45 -7 99 -7 l100 0 21 58 c11 31 23 63 25 70 6
17 295 18 295 1 0 -7 10 -38 21 -70 l22 -59 103 0 c57 0 104 2 104 4 0 2 -63
171 -141 377 -77 206 -143 382 -146 392 -5 15 -19 17 -109 17 -99 0 -105 -1
-113 -22z m158 -327 c23 -71 41 -134 41 -140 0 -7 -31 -11 -90 -11 -49 0 -90
3 -90 6 0 7 81 257 87 267 2 4 6 7 8 7 1 0 21 -58 44 -129z"/>
<path d="M7760 5245 l0 -85 120 0 120 0 0 -310 0 -310 105 0 106 0 -1 298 c0
163 0 303 0 310 0 9 30 12 115 12 l115 0 0 85 0 85 -340 0 -340 0 0 -85z"/>
<path d="M8612 5238 c-18 -51 -37 -102 -42 -113 -5 -11 -52 -135 -104 -275
-52 -140 -99 -267 -105 -282 l-11 -28 105 0 104 0 22 70 23 70 143 0 c106 0
145 -3 148 -12 2 -7 14 -39 25 -70 l21 -58 100 0 c111 0 109 -2 80 75 -10 28
-62 167 -115 310 -53 143 -109 292 -124 330 l-27 70 -105 3 -106 3 -32 -93z
m187 -268 c23 -69 41 -128 41 -132 0 -5 -40 -8 -90 -8 -64 0 -90 4 -90 12 0
26 85 267 92 260 4 -4 25 -63 47 -132z"/>
<path d="M4133 5289 c-3 -11 -7 -19 -8 -19 -2 0 -32 7 -66 16 -96 25 -210 16
-284 -22 -195 -98 -276 -326 -185 -521 72 -155 244 -249 407 -223 34 6 74 15
88 20 38 14 45 13 45 -10 0 -20 5 -21 103 -18 l102 3 3 389 c2 305 -1 391 -10
398 -7 4 -53 8 -102 7 -77 -1 -89 -4 -93 -20z m-98 -222 c137 -78 116 -286
-35 -331 -98 -29 -185 12 -225 106 -37 89 5 195 93 235 46 20 122 15 167 -10z"/>
<path d="M5333 5294 c-2 -7 -3 -118 -1 -246 4 -201 7 -240 23 -281 48 -120
161 -214 289 -242 69 -16 82 -16 148 -1 40 8 83 18 96 22 20 6 22 3 22 -27 -1
-43 -23 -104 -47 -131 -31 -35 -85 -55 -161 -61 -180 -14 -328 -146 -364 -321
-6 -31 -8 -60 -4 -64 10 -9 149 -16 179 -8 16 4 26 18 35 49 13 44 56 94 98
116 12 6 59 15 105 20 46 5 102 17 124 26 94 39 184 133 221 230 18 47 19 80
19 490 l0 440 -100 0 -100 0 -5 -225 c-5 -240 -9 -258 -62 -307 -32 -30 -71
-43 -129 -43 -58 0 -97 17 -132 60 -40 48 -47 90 -47 306 0 181 -2 203 -17
208 -32 12 -184 4 -190 -10z"/>
</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
